const MAP_SLUGS_TO_ICONS = {
  // slug (from contentful) : svg (name from ui)
  'visiting-with-kids': 'kids-playworld',
  parking: 'unmetered-parking',
  concierge: 'info-concierge',
  'valet-parking': 'valet-parking',
  wifi: 'wifi',
  'free-wifi': 'wifi',
  community: 'community-rooms',
  accessibility: 'mobility-scooter-hire',
  'personal-styling': 'fashion-styling',
  'handsfree-shopping': 'handsfree-shopping',
  'getting-here': 'map-directions',
  'justice-of-the-peace': 'justice-of-the-peace',
  'westfield-suite': 'westfield-suite',
  'interior-styling': 'interior-styling',
  'gift-card': 'gift-cards',
  'westfield-app': 'westfield-app',
  childcare: 'family',
  'apple-music': 'music',
  'guest-services': 'info-concierge',
  'customer-service': 'info-concierge',
  'st-lukes-shoppers-creche': 'kids-playworld',
  sustainability: 'sustainability',
  'westfield-direct': 'westfield-direct',
  'click-and-collect': 'westfield-direct',
  'westfield-direct-service': 'westfield-direct-service',
  'westfield-plus': 'westfield-plus',
}

export { MAP_SLUGS_TO_ICONS }
